var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { sdsCustomElement } from '../utilities/custom-components';
import { repeat } from 'lit/directives/repeat.js';
let SdsActionListItem = (() => {
    var _SdsActionListItem_isPrimary_accessor_storage, _SdsActionListItem_identifier_accessor_storage, _SdsActionListItem_name_accessor_storage, _SdsActionListItem_tooltip_accessor_storage, _SdsActionListItem_icon_accessor_storage, _SdsActionListItem_terminator_accessor_storage, _SdsActionListItem_disabled_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-action-list-item')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _isPrimary_decorators;
    let _isPrimary_initializers = [];
    let _isPrimary_extraInitializers = [];
    let _identifier_decorators;
    let _identifier_initializers = [];
    let _identifier_extraInitializers = [];
    let _name_decorators;
    let _name_initializers = [];
    let _name_extraInitializers = [];
    let _tooltip_decorators;
    let _tooltip_initializers = [];
    let _tooltip_extraInitializers = [];
    let _icon_decorators;
    let _icon_initializers = [];
    let _icon_extraInitializers = [];
    let _terminator_decorators;
    let _terminator_initializers = [];
    let _terminator_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    var SdsActionListItem = _classThis = class extends _classSuper {
        /**
         * Indicates whether the action item is displayed as a primary action.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} is-primary - Displays the action item as a primary action.
         */
        get isPrimary() { return __classPrivateFieldGet(this, _SdsActionListItem_isPrimary_accessor_storage, "f"); }
        set isPrimary(value) { __classPrivateFieldSet(this, _SdsActionListItem_isPrimary_accessor_storage, value, "f"); }
        /**
         * A unique identifier for the action item.
         * This can be used for programmatic access or to distinguish between multiple items.
         *
         * Defaults to `undefined`.
         *
         * @attr {string} identifier - A unique identifier for the action item.
         */
        get identifier() { return __classPrivateFieldGet(this, _SdsActionListItem_identifier_accessor_storage, "f"); }
        set identifier(value) { __classPrivateFieldSet(this, _SdsActionListItem_identifier_accessor_storage, value, "f"); }
        /**
         * The display name of the action item.
         * This is the text shown to users and should convey the purpose of the action clearly.
         *
         * Defaults to `undefined`.
         *
         * @attr {string} name - The display name of the action item.
         */
        get name() { return __classPrivateFieldGet(this, _SdsActionListItem_name_accessor_storage, "f"); }
        set name(value) { __classPrivateFieldSet(this, _SdsActionListItem_name_accessor_storage, value, "f"); }
        /**
         * The text to display as a tooltip when the user hovers over the item.
         * Tooltips can provide additional context or instructions regarding the action item.
         *
         * Defaults to `undefined`.
         *
         * @attr {string} tooltip - The tooltip text for the action item.
         */
        get tooltip() { return __classPrivateFieldGet(this, _SdsActionListItem_tooltip_accessor_storage, "f"); }
        set tooltip(value) { __classPrivateFieldSet(this, _SdsActionListItem_tooltip_accessor_storage, value, "f"); }
        /**
         * Specifies the icon to display alongside the action item’s name.
         * This can enhance the visual representation and help users quickly identify the action.
         *
         * Defaults to `undefined`.
         *
         * @attr {string} icon - The icon for the action item.
         */
        get icon() { return __classPrivateFieldGet(this, _SdsActionListItem_icon_accessor_storage, "f"); }
        set icon(value) { __classPrivateFieldSet(this, _SdsActionListItem_icon_accessor_storage, value, "f"); }
        get terminator() { return __classPrivateFieldGet(this, _SdsActionListItem_terminator_accessor_storage, "f"); }
        set terminator(value) { __classPrivateFieldSet(this, _SdsActionListItem_terminator_accessor_storage, value, "f"); }
        get disabled() { return __classPrivateFieldGet(this, _SdsActionListItem_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsActionListItem_disabled_accessor_storage, value, "f"); }
        updated(changed) {
            if (changed.has('name') || changed.has('tooltip')) {
                this.dispatchEvent(new CustomEvent(SdsActionListItem.ACTION_LIST_ITEM_CHANGE, {
                    bubbles: true,
                    composed: true,
                }));
            }
        }
        renderButton(clickHandler) {
            if (this.children.length > 0) {
                return this.renderButtonWithDropDown(clickHandler);
            }
            if (this.tooltip) {
                return this.renderButtonWithTooltip(clickHandler);
            }
            return this.renderSingleButton(clickHandler);
        }
        renderSingleButton(clickHandler) {
            return html ` <sds-button
            type="ghost"
            size="md"
            ?disabled=${this.disabled}
            icon=${this.icon}
            primary
            @click=${(event) => this.handleClickHandler(event, this.identifier, clickHandler)}
        >
        </sds-button>`;
        }
        renderButtonWithTooltip(clickHandler) {
            const button = html ` <sds-button
            type="ghost"
            size="md"
            ?disabled=${this.disabled}
            icon=${this.icon}
            primary
            @click=${(event) => this.handleClickHandler(event, this.identifier, clickHandler)}
            slot="trigger"
        >
        </sds-button>`;
            return html `<sds-tooltip position="up" basic>${button} ${this.tooltip}</sds-tooltip>`;
        }
        renderButtonWithDropDown(clickHandler) {
            return html `
            <sds-button-dropdown
                type="ghost"
                size="md"
                ?disabled=${this.disabled}
                icon=${this.icon}
                primary
                slot="trigger"
                @click=${(event) => this.handleClickHandler(event, this.identifier, clickHandler)}
            >
                ${repeat(Array.from(this.children), item => item.identifier, item => this.renderCmItem(item, clickHandler))}
            </sds-button-dropdown>
        `;
        }
        renderContextMenuItem(clickHandler) {
            if (this.children.length > 0) {
                return this.renderContextMenuGroup(clickHandler);
            }
            return this.renderCmItem(this, clickHandler);
        }
        renderContextMenuGroup(clickHandler) {
            return html ` <sds-cm-group name=${this.name}>
            ${repeat(Array.from(this.children), item => item.identifier, item => this.renderCmItem(item, clickHandler))}
        </sds-cm-group>`;
        }
        renderCmItem(item, clickHandler) {
            return html `
            <sds-cm-item
                name=${item.name}
                ?disabled=${item.disabled || this.disabled}
                ?warn-item=${item.terminator}
                with-icon
                @click=${(event) => this.handleClickHandler(event, item.identifier, clickHandler)}
            >
                <sds-icon slot="icon" name=${item.icon} size="16"></sds-icon>
            </sds-cm-item>
        `;
        }
        handleClickHandler(event, identifier, clickHandler) {
            event.stopPropagation();
            event.preventDefault();
            clickHandler(identifier);
        }
        constructor() {
            super(...arguments);
            _SdsActionListItem_isPrimary_accessor_storage.set(this, __runInitializers(this, _isPrimary_initializers, false));
            _SdsActionListItem_identifier_accessor_storage.set(this, (__runInitializers(this, _isPrimary_extraInitializers), __runInitializers(this, _identifier_initializers, void 0)));
            _SdsActionListItem_name_accessor_storage.set(this, (__runInitializers(this, _identifier_extraInitializers), __runInitializers(this, _name_initializers, void 0)));
            _SdsActionListItem_tooltip_accessor_storage.set(this, (__runInitializers(this, _name_extraInitializers), __runInitializers(this, _tooltip_initializers, void 0)));
            _SdsActionListItem_icon_accessor_storage.set(this, (__runInitializers(this, _tooltip_extraInitializers), __runInitializers(this, _icon_initializers, void 0)));
            _SdsActionListItem_terminator_accessor_storage.set(this, (__runInitializers(this, _icon_extraInitializers), __runInitializers(this, _terminator_initializers, false)));
            _SdsActionListItem_disabled_accessor_storage.set(this, (__runInitializers(this, _terminator_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            __runInitializers(this, _disabled_extraInitializers);
        }
    };
    _SdsActionListItem_isPrimary_accessor_storage = new WeakMap();
    _SdsActionListItem_identifier_accessor_storage = new WeakMap();
    _SdsActionListItem_name_accessor_storage = new WeakMap();
    _SdsActionListItem_tooltip_accessor_storage = new WeakMap();
    _SdsActionListItem_icon_accessor_storage = new WeakMap();
    _SdsActionListItem_terminator_accessor_storage = new WeakMap();
    _SdsActionListItem_disabled_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsActionListItem");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _isPrimary_decorators = [property({ type: Boolean, attribute: 'is-primary' })];
        _identifier_decorators = [property()];
        _name_decorators = [property({ type: String, reflect: true })];
        _tooltip_decorators = [property({ type: String, reflect: true })];
        _icon_decorators = [property({ type: String })];
        _terminator_decorators = [property({ type: Boolean })];
        _disabled_decorators = [property({ type: Boolean })];
        __esDecorate(_classThis, null, _isPrimary_decorators, { kind: "accessor", name: "isPrimary", static: false, private: false, access: { has: obj => "isPrimary" in obj, get: obj => obj.isPrimary, set: (obj, value) => { obj.isPrimary = value; } }, metadata: _metadata }, _isPrimary_initializers, _isPrimary_extraInitializers);
        __esDecorate(_classThis, null, _identifier_decorators, { kind: "accessor", name: "identifier", static: false, private: false, access: { has: obj => "identifier" in obj, get: obj => obj.identifier, set: (obj, value) => { obj.identifier = value; } }, metadata: _metadata }, _identifier_initializers, _identifier_extraInitializers);
        __esDecorate(_classThis, null, _name_decorators, { kind: "accessor", name: "name", static: false, private: false, access: { has: obj => "name" in obj, get: obj => obj.name, set: (obj, value) => { obj.name = value; } }, metadata: _metadata }, _name_initializers, _name_extraInitializers);
        __esDecorate(_classThis, null, _tooltip_decorators, { kind: "accessor", name: "tooltip", static: false, private: false, access: { has: obj => "tooltip" in obj, get: obj => obj.tooltip, set: (obj, value) => { obj.tooltip = value; } }, metadata: _metadata }, _tooltip_initializers, _tooltip_extraInitializers);
        __esDecorate(_classThis, null, _icon_decorators, { kind: "accessor", name: "icon", static: false, private: false, access: { has: obj => "icon" in obj, get: obj => obj.icon, set: (obj, value) => { obj.icon = value; } }, metadata: _metadata }, _icon_initializers, _icon_extraInitializers);
        __esDecorate(_classThis, null, _terminator_decorators, { kind: "accessor", name: "terminator", static: false, private: false, access: { has: obj => "terminator" in obj, get: obj => obj.terminator, set: (obj, value) => { obj.terminator = value; } }, metadata: _metadata }, _terminator_initializers, _terminator_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsActionListItem = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.ACTION_LIST_ITEM_CHANGE = 'sds.action-list_item.change';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsActionListItem = _classThis;
})();
export { SdsActionListItem };
